const themeTag = 'data-theme';

export function loadTheme(themeName: string): void {
  const head = document?.getElementsByTagName('html')?.[0];
  head?.setAttribute(themeTag, themeName);
}
